<template>
  <v-container text-md-center justify-center>
    <v-row>
      <v-col class="justify-center">
        <user-detail-compornent :userId="userId">
        </user-detail-compornent>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <user-record-compornent :userId="userId" />
  </v-container>
</template>
<script>
import UserDetailCompornent from "../components/UserDetail";
import UserRecordCompornent from "../components/UserRecord";
import firebase from "firebase";
import "firebase/firestore";
import {mapActions} from 'vuex'
export default {
  name: "ShowUser",
  components: {
    UserDetailCompornent,
    UserRecordCompornent,
  },
  data() {
    return {
      friendFlag: false,
      userId: this.$route.params.userId
    }
  },
  created(){
    if(this.$store.getters.userId===this.$route.params.userId){
      this.$router.push({name: "User"})
    }
    this.closeCommentModal()
    const db = firebase.firestore();
    db.collection("users").doc(this.$store.getters.userId).collection("friends").get().then(friends => {
      friends.forEach((friend) => {
        if(friend.data().friendUserId==this.$route.params.userId){
          this.friendFlag = true;
        }
      })
    })
    this.fetchUserData(this.userId)
  },
  methods: {
    ...mapActions(['closeCommentModal','fetchUserData'])
  }
};
</script>
